import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useGetProviderTimeSlotsQuery } from "src/api/services/availabilityApi";
import { STATUS } from "src/constants/searchParams";
import { useFromAndTo } from "src/hooks/useFromAndTo";
import DataTable from "src/components/DataTable";
import { useColumns } from "./useColumns";
import { usePagination } from "src/hooks/usePagination";
import { MatchParam } from "src/constants/matches";

const ProviderAvailabilityDetail = () => {
  const { availabilityId } = useParams<MatchParam<"AVAILABILITY_ID">>();
  const [params] = useSearchParams();

  const { from, to } = useFromAndTo();
  const columns = useColumns(availabilityId);
  const pagination = usePagination();

  const queryParams = useMemo(() => {
    if (availabilityId != null) {
      return {
        availability_id: Number(availabilityId),
        status: params.get(STATUS) ?? undefined,
        from,
        to,
      };
    }

    return {
      status: params.get(STATUS) ?? undefined,
      from,
      to,
    };
  }, [availabilityId, params, from, to]);

  const height = useMemo(() => window.innerHeight - 104 - 64 - 34 - 200, []);

  const { data, isFetching } = useGetProviderTimeSlotsQuery(queryParams);

  const { timeSlots, count } = useMemo(() => {
    if (data == null) return { timeSlots: [], count: 0 };
    return { timeSlots: data.data, count: data.count };
  }, [data]);

  return (
    <Stack gap="32px">
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" fontWeight={600}>
          {`Availability`}
        </Typography>
      </Stack>

      <Stack gap={2}>
        <Typography variant="h6" fontWeight={600}>
          Time Slots
        </Typography>
        {/* <Stack
          direction="row"
          gap="16px"
          height={60}
          width="100%"
          alignItems="center"
        >
          {filters.map((filter) => (
            <Filter key={filter.name} current={filter} />
          ))}
        </Stack> */}
        <Stack gap={0}>
          <Box height={4}>
            {isFetching ? <LinearProgress color="secondary" /> : null}
          </Box>
          <DataTable
            columns={columns}
            data={timeSlots}
            total={count}
            primaryKey="id"
            height={height}
            pagination={pagination}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ProviderAvailabilityDetail;
